export default {
  // 根据角色id查询角色项目系统权限
  selectRoleSystemListByRoleIdApi: '/backstageApi/account/backstage/roleSystem/selectListByRoleId',
  // 新增角色项目系统权限
  insertRoleSystemApi: '/backstageApi/account/backstage/roleSystem/save',
  // 所有项目系统列表
  selectAllSystemApi: '/backstageApi/account/backstage/management/queryManagementAll',
  // 新增角色菜单权限
  addRoleAuthApi: '/backstageApi/account/backstage/sysRole/addRoleAuth',
  // 获取渠道项目经理
  getChannelBusinessApi: '/backstageApi/account/backstage/sysUser/getChannelBusiness',
  // 获取当前登录人信息
  getLoginUserInfoApi: '/backstageApi/account/backstage/sysUser/getLoginUserInfo',
  // 更新用户信息
  editSysUserApi: '/backstageApi/account/backstage/sysUser/editSysUser',
  // 用户列表分页查询
  queryUserInfoPageApi: '/backstageApi/account/backstage/sysUser/queryUserInfoPage',
  // 渠道与App应用渠道关系
  selectAppChannelNoApi: '/backstageApi/account/backstage/usercenter/channel/selectAppChannelNo',
  // 新增渠道与App应用渠道关系
  insertRelationApi: '/backstageApi/account/backstage/usercenter/channel/insertRelation',
  // 根据设备SN号查询
  selectByDeviceNameApi: '/backstageApi/account/backstage/usercenter/device/selectByDeviceName',
  // 根据机型id查询ota版本
  selectVersionByModelIdApi: '/backstageApi/account/backstage/BI/selectVersionByModelId',

  // 根据路径删除文件
  deleteFileAPi: '/fileApi/sysfile/deleteFile',

}



// WEBPACK FOOTER //
// ./src/api/user/role.js